import {
    FormOverview_VM,
    FormsOverviewComponent
} from "./FormsOverview.component";
import { useFormsOverviewViewModel } from "./useFormsOverviewViewModel";

export function FormsOverviewScreen() {
    const vm: FormOverview_VM = useFormsOverviewViewModel();
    return <FormsOverviewComponent {...vm} />;
}
